import { render, staticRenderFns } from "./GalleryTip.vue?vue&type=template&id=9904db04&scoped=true&"
import script from "./GalleryTip.vue?vue&type=script&lang=ts&"
export * from "./GalleryTip.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryTip.vue?vue&type=style&index=0&id=9904db04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9904db04",
  null
  
)

export default component.exports